import { v4 as uuid } from "uuid";

const itemsFromBackend = [
  { id: uuid(), 
    strat_acct_name: "Anheuser-Busch",
    content: "First task", 
    farm: "Kreiger - Windler", 
    contactName: "Arthur Robel", 
    dealer: "Kunde LLC", 
    rebateAmt: 2200.95, 
    status: "Rejected", 
    rejectReason: "Rebate expired", 
    invoiceNumber: "1038",
    uploadDate: Date.now(),
    invoiceDate: Date.now()-1000,
    totalExtRetailPrice: 5221.00,
    items: [
      {id: 199, part: "12938a", desc: "Pivot part", quantity: 10, retail_price: 10.99, ext_price: 109.99},
      {id: 200, part: "12938a", desc: "Water filter", quantity: 10, retail_price: 10.99, ext_price: 109.99},
      {id: 201, part: "12938a", desc: "Pivot part", quantity: 10, retail_price: 10.99, ext_price: 109.99},
      {id: 202, part: "12938a", desc: "Water filter", quantity: 10, retail_price: 10.99, ext_price: 109.99},
      {id: 203, part: "12938a", desc: "Pivot part", quantity: 10, retail_price: 10.99, ext_price: 109.99},
      {id: 204, part: "12938a", desc: "Water filter", quantity: 10, retail_price: 10.99, ext_price: 109.99},
      {id: 205, part: "12938a", desc: "Pivot part", quantity: 10, retail_price: 10.99, ext_price: 109.99},
      {id: 206, part: "12938a", desc: "Water filter", quantity: 10, retail_price: 10.99, ext_price: 109.99},
      {id: 207, part: "12938a", desc: "Water filter", quantity: 10, retail_price: 10.99, ext_price: 109.99},
      {id: 208, part: "12938a", desc: "Water filter", quantity: 10, retail_price: 10.99, ext_price: 109.99},
      {id: 209, part: "12938a", desc: "Water filter", quantity: 10, retail_price: 10.99, ext_price: 109.99},
      {id: 210, part: "12938a", desc: "Water filter", quantity: 10, retail_price: 10.99, ext_price: 109.99}

    ]
  },
  { id: uuid(), content: "Second task", farm: "Pouros and Sons", contactName: "Lillian Wisozk", dealer: "Champlin - Schimmel", rebateAmt: "$520.95", status: "Approved" , invoiceNumber: "151"  },
  { id: uuid(), content: "Third task",farm: "Shields Inc", contactName: "Joseph Herman", dealer: "Marks Inc", rebateAmt: "$1,222.95", status: "Approved", invoiceNumber: "7011"  },
  { id: uuid(), content: "Fourth task",farm: "O'Connell LLC", contactName: "Beth McDermott", dealer: "Lopez Ag Supply", rebateAmt: "$900.05", status: "New", invoiceNumber: "6011"  },
  { id: uuid(), content: "Fifth task",farm: "Crist - Marquardt", contactName: "Jessie Williams", dealer: "Marks Irrigation", rebateAmt: "$200.00" , status: "New" , invoiceNumber: "171"  },
];

export const status = {
  [uuid()]: {
    name: "Rejected",
    color: "#ededed",
    hoverColor: "#FEF3F2",
    items: itemsFromBackend?.filter(item=> item?.status == "Rejected")
  },
  [uuid()]: {
    name: "New",
    color: "#ededed",
    hoverColor: "#EAECF5",
    items: itemsFromBackend?.filter(item=> item?.status == "New")
  },
  [uuid()]: {
    name: "Approved",
    color: "#ededed",
    hoverColor: "#EAECF5",
    items: itemsFromBackend?.filter(item=> item?.status == "Approved")
  }
};
